import api from '@/api'
import socket from '@/plugins/socket'
import i18n from '@/plugins/i18n.plugin'

const state = {
  loading: false,

  environment: null
}

const getters = {
  loading: (state) => state.loading,

  environment: (state) => state.environment

}

const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading
  },

  SET_ENVIRONMENT(state, environment) {
    state.environment = environment
  }
}

const actions = {
  async init({ commit, dispatch /*, rootGetters*/ }) {
    commit('SET_LOADING', true);

    try {
      socket.connect();
      const results = await Promise.allSettled([

        // Necesarios
        dispatch('fetchEnvironment'),
        dispatch('usuario/fetchCurrentUser', null, { root: true }),
        dispatch('recurso/fetchRecursos', null, { root: true }),
        dispatch('usuario/fetchUsuarios', null, { root: true }),
        dispatch('rol/fetchRoles', null, { root: true }),
        dispatch('permiso/fetchPermisos', null, { root: true }),

        // Permanentes
        dispatch('permiso/fetchPermisosTipos', null, { root: true }),
        dispatch('incendio/fetchTiposGravedadPotencial', null, { root: true }),
        dispatch('demarcacion/fetchDemarcaciones', null, { root: true }),
        dispatch('incendio/fetchTiposDeteccion', null, { root: true }),
        dispatch('recurso/fetchRecursoEstadoTipos', null, { root: true }),
        dispatch('recursoTipo/fetchTiposRecurso', null, { root: true }),
        dispatch('recursoCategoria/fetchCategoriasRecurso', null, { root: true }),
        dispatch('recursoClase/fetchClaseRecurso', null, { root: true }),
        dispatch('icono/fetchIconos', null, { root: true }),
        dispatch('medioPersonal/fetchTurnos', null, { root: true }),
        dispatch('recursoSector/fetchCanalesComunicacion', null, { root: true }),
        dispatch('recursoSector/fetchEstadosAccion', null, { root: true }),
        dispatch('parametro/fetchParametros', null, { root: true }),
        dispatch('infraestructura/fetchTipos', null, { root: true }),
        dispatch('infraestructura/fetchCategorias', null, { root: true }),
        dispatch('infraestructura/fetchMunicipios', null, { root: true }),
        dispatch('infraestructura/fetchProvincias', null, { root: true }),
        dispatch('infraestructura/fetchOrganismos', null, { root: true }),
        dispatch('tituloProfesional/fetchTitulosProfesionales', null, { root: true }),
        dispatch('organismo/fetchOrganismos', null, { root: true }),
        dispatch('dispositivo/fetchGeoResponsables', null, { root: true }),
        dispatch('emergencia/fetchEmergenciasTipo', null, { root: true }),
        dispatch('emergencia/fetchEmergenciaEstadoTipo', null, { root: true }),

        dispatch('recursoRecursoTipo/fetchRecursoRecursoTipo', null, { root: true }),
        dispatch('medioPersonal/ensureBaseGuardias', null, { root: true }),
        dispatch('recurso/fetchEstadosRecurso', null, { root: true }),
        dispatch('infraestructura/fetchInfraestructuras', null, { root: true }),

        dispatch('emergencia/fetchEmergenciaNivel', null, { root: true }),

        dispatch('dispositivo/fetchDispositivos', null, { root: true }),
        dispatch('dispositivo/fetchStatusConnection', null, { root: true }),

        dispatch('geofencing/fetchGeofencings', null, { root: true }),
      ]);

      // allSettled nunca rechaza: sin esto un fetch caido arrancaria la app con
      // datos incompletos y sin señal alguna.
      results.forEach((result, index) => {
        if (result.status === 'rejected') console.error(`Error init data [dispatch #${index}]:`, result.reason);
      });

      if (results.some((result) => result.status === 'rejected')) {
        this.notify(i18n.t('alert.error.error'), i18n.t('alert.error.initialDataLoad'), 'error');
      }

      dispatch('medioPersonal/startDayRollover', null, { root: true });

      await dispatch('usuario/userLoggedIn', null, { root: true });
    } catch (error) {
      console.error(`Error init data ${error}`);
      this.notify(i18n.t('alert.error.error'), i18n.t('alert.error.initialDataLoad'), 'error');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async reSyncAfterReconnect({ dispatch }) {
    try {
      const results = await Promise.allSettled([
        dispatch('usuario/userLoggedIn', null, { root: true }),
        dispatch('recurso/fetchRecursos', null, { root: true }),
        dispatch('emergencia/fetchEmergencias', null, { root: true }),
        dispatch('dispositivo/fetchDispositivos', null, { root: true }),
        dispatch('infraestructura/fetchInfraestructuras', null, { root: true }),
        dispatch('geofencing/fetchGeofencings', null, { root: true }),
        dispatch('medioPersonal/reloadLoadedGuardias', null, { root: true }),
      ]);

      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Error reSyncAfterReconnect [dispatch #${index}]:`, result.reason);
        }
      });

      if (results.some((result) => result.status === 'rejected')) {
        this.notify(i18n.t('alert.error.error'), i18n.t('alert.error.initialDataLoad'), 'error');
      }
    } catch (error) {
      console.error(`Error reSyncAfterReconnect ${error}`);
      this.notify(i18n.t('alert.error.error'), i18n.t('alert.error.initialDataLoad'), 'error');
    }
  },

  async fetchEnvironment({ commit }) {
    try {
      const response = await api.appInfo.getEnviroment()
      commit('SET_ENVIRONMENT', response.data.env)
    } catch (error) {
      console.error(`Error fetching environment ${error}`);
      this.notify('Error', 'Error al realizar la carga de datos de entorno', 'error');
    }
  },


  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
